import { createAction } from '@ngrx/store';

export const StartSpeechRecognition = createAction(
  '[SpeechRecognition] Start Speech Recognition'
);

export const StopSpeechRecognition = createAction(
  '[SpeechRecognition] Stop Speech Recognition'
);